import { z } from 'zod'
import { AssigneeEntity } from '@omnea-app/core/blocks'

export const PauseRequestFormValidationSchema = z.object({
  assignee: z.object(
    {
      id: z.string(),
    },
    { message: 'pause.errors.assignee-required' }
  ),
  reminderDate: z
    .date({ message: 'pause.errors.reminder-required' })
    .min(new Date(), { message: 'pause.errors.reminder-future' }),
  reason: z.object({ id: z.string() }, { message: 'pause.errors.reason-required' }),
  note: z.string().nullable(),
})

export interface PauseRequestFormValues {
  assignee: AssigneeEntity | null
  reminderDate: Date | null
  reason: { id: string; label: string } | null
  note: string | null
}

export const initialFormValues: PauseRequestFormValues = {
  assignee: null,
  reminderDate: null,
  reason: null,
  note: null,
}
